import { interpolateStringWithData } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import { Alert } from '../../atoms/Alert/Alert';
import { Button } from '../../atoms/Button';
import { WriteReviewModal } from '../WriteReviewModal';
import { PurchasedItemProps } from './PurchasedItem.types';

export const PurchasedItem = ({
  ownedDate,
  canWriteReview,
  microcopy,
  writeReviewModal,
  onEmailPublisher,
  onSubmitReview,
  className = '',
}: PurchasedItemProps) => {
  const ownedDateLabel = ownedDate
    ? interpolateStringWithData(microcopy.ownedDate, { date: ownedDate })
    : undefined;

  if (!canWriteReview) {
    if (!ownedDateLabel) {
      return null;
    }
    return <Alert label={ownedDateLabel} className={className} />;
  }

  return (
    <Alert
      className={c('text-left', className)}
      label={
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-col text-sm leading-5 tracking-tight">
            <p className="font-bold text-grey-900">{microcopy.title}</p>
            <p className="mt-1 font-normal text-grey-700">
              {microcopy.subTitle}
            </p>
            {ownedDateLabel ? (
              <p className="mt-1 font-normal text-grey-500">{ownedDateLabel}</p>
            ) : null}
          </div>
          <WriteReviewModal
            className="w-full md:w-auto md:shrink-0"
            productId={writeReviewModal.productId}
            title={writeReviewModal.title}
            imageUrl={writeReviewModal?.imageUrl}
            version={writeReviewModal?.version}
            ownedDate={writeReviewModal?.ownedDate}
            isMultiPackage={writeReviewModal?.isMultiPackage || false}
            microcopy={microcopy.writeReviewModal}
            onEmailPublisher={onEmailPublisher}
            onSubmitReview={onSubmitReview}
            reviewModalTrigger={
              <Button.v2
                type="button"
                variant="primary"
                size="medium"
                shape="square"
                label={microcopy.buttonLabel}
              />
            }
          />
        </div>
      }
    />
  );
};
